import { useMemo } from "react";
import { useSessionFetcher } from "./useSessionFetcher";

type ToolkitSession = NonNullable<ReturnType<typeof useSessionFetcher>["data"]>;

function getSessionUser(session?: ToolkitSession) {
  if (!session) return undefined;

  switch (session.type) {
    case "teacher":
      return session.teacher;
    case "parent":
      return session.parent;
    case "student":
      return session.student;
    default:
      return undefined;
  }
}

export function useToolkitSession() {
  const fetcher = useSessionFetcher({});

  return useMemo(() => {
    const session = fetcher.data;
    const user = getSessionUser(session);

    return {
      ...fetcher,
      session,
      user,
      userConfig: session?.userConfig,
      isLoggedIn: !!user,
    };
  }, [fetcher]);
}
